var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"line-height":"10.39mm","letter-spacing":"-0.4pt","word-break":"break-all","font-family":"仿宋_GB2312","font-size":"16pt"},domProps:{"innerHTML":_vm._s(_vm.html)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }